<template>
  <div
    class="grid grid-rows-[auto_1fr] overflow-hidden h-full mate-wish-edit-page"
  >
    <ThreadsNav :show-back="true" :show-center="false">
      <template #right>
        <CrystalPowerCount />
      </template>
    </ThreadsNav>
    <div class="pb-28 overflow-auto">
      <!-- <VanTabs v-model="activeTab">
        <VanTab title="祈愿内容" name="description"> -->
      <VanCellGroup inset class="mt-1">
        <!-- <VanCell @click="clickSelectLead">
          <template #title>
            <div class="flex items-center justify-between gap-2">
              <div>
                {{ $t(`mateWish.lead`) }}
                <span class="text-xs text-base-content/30">
                  {{ $t(`mateWish.optional`) }}
                </span>
              </div>
              <div class="text-xs text-base-content/30 flex items-center">
                {{ $t(`mateWish.select`) }}
                <i class="iconify mingcute--right-line w-6"></i>
              </div>
            </div>
          </template>
          <template #label v-if="mateWish.characterIdzz?.length">
            <div class="flex flex-wrap gap-2 py-2" @click.stop>
              <div
                class="w-[60px] relative flex flex-col gap-1 items-center"
                v-for="mateId in mateWish.characterIdzz"
                :key="mateId"
              >
                <button
                  class="bg-neutral w-5 h-5 rounded-full flex items-center justify-center absolute top-0 right-0 z-[1]"
                  @click="
                    mateWish.characterIdzz = mateWish.characterIdzz.filter(
                      (id) => id !== mateId
                    )
                  "
                >
                  <i
                    class="iconify mdi--close text-xs w-3 text-neutral-content"
                  />
                </button>

                <BaseImg
                  :mate="mateStore.mateIdMap.get(Number(mateId))"
                  ratio="3:4"
                />
                <div class="text-xs line-clamp-1">
                  {{ mateStore.mateIdMap.get(Number(mateId))?.name }}
                </div>
              </div>
            </div>
          </template>
        </VanCell> -->

        <VanCell>
          <template #title>
            <div class="flex items-center justify-between gap-2">
              <div class="flex items-center gap-2">
                {{ $t(`trait.tab.img`) }}
                <span class="text-xs text-base-content/50">(最多 6 张)</span>
              </div>
              <!-- <div class="text-xs text-base-content/30 flex items-center">
                <span>{{ $t(`trait.select`) }}</span>
                <i class="iconify mingcute--right-line w-6"></i>
              </div> -->
            </div>
          </template>
          <template #label>
            <div class="flex flex-wrap gap-2 py-2" @click.stop>
              <template v-if="mateWish.referenceImagezz?.length">
                <div
                  class="w-[60px] relative flex flex-col gap-1 items-center"
                  v-for="media in mateWish.referenceImagezz"
                  :key="media.id"
                >
                  <button
                    class="bg-neutral w-5 h-5 rounded-full flex items-center justify-center absolute top-0 right-0 z-[1]"
                    @click="
                        ((mateWish.referenceImagezz =
                          mateWish.referenceImagezz.filter(
                            (img) => img.id !== media.id
                          )),
                        (mateWish.referenceImagezz =
                          mateWish.referenceImagezz!.filter(
                            (img) => img.id !== media.id
                          )))
                      "
                  >
                    <i
                      class="iconify mdi--close text-xs w-3 text-neutral-content"
                    />
                  </button>

                  <BaseImg :url="media.url" ratio="3:4" />
                </div>
              </template>
              <div
                class="flex flex-col gap-1 w-[60px]"
                v-if="(mateWish.referenceImagezz?.length ?? 0) < 6"
                @click="showStyleImgUploadPopup = true"
              >
                <div
                  class="aspect-[3/4] border-primary-content border-dashed rounded-lg flex justify-center items-center bg-neutral h-full"
                >
                  <div
                    class="w-[40%] aspect-square overflow-hidden flex items-center justify-center border border-dashed rounded-full border-neutral-content"
                  >
                    <i
                      class="iconify mingcute--add-line text-neutral-content font-light w-[80%]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </VanCell>
        <VanField
          type="textarea"
          :label="$t(`mateWish.content`)"
          label-align="top"
          :autosize="{ maxHeight: 100, minHeight: 50 }"
          :placeholder="$t(`mateWish.contentPlaceholder`)"
          v-model="mateWish.content"
        />
      </VanCellGroup>
      <!-- </VanTab>
        <VanTab title="祈愿设置" name="settings"> -->
      <VanCellGroup inset class="mt-1">
        <!-- <VanCell @click="showStyleImgUploadPopup = true">
          <template #title>
            <div class="flex items-center justify-between gap-2">
              <div>
                {{ $t(`mateWish.settings.style`) }}
              </div>
              <div class="text-xs text-base-content/30 flex items-center">
                <span>{{ $t(`trait.select`) }}</span>
                <i class="iconify mingcute--right-line w-6"></i>
              </div>
            </div>
          </template>
          <template #label v-if="mateWish.referenceImageIdzz?.length">
            <div class="flex flex-wrap gap-2 py-2" @click.stop>
              <div
                class="w-[60px] relative flex flex-col gap-1 items-center"
                v-for="media in mateWish.referenceImagezz"
                :key="media.id"
              >
                <button
                  class="bg-neutral w-5 h-5 rounded-full flex items-center justify-center absolute top-0 right-0 z-[1]"
                  @click="
                        ((mateWish.referenceImageIdzz =
                          mateWish.referenceImageIdzz.filter(
                            (img) => img !== media.id
                          )),
                        (mateWish.referenceImagezz =
                          mateWish.referenceImagezz!.filter(
                            (img) => img.id !== media.id
                          )))
                      "
                >
                  <i
                    class="iconify mdi--close text-xs w-3 text-neutral-content"
                  />
                </button>

                <BaseImg :url="media.url" ratio="3:4" />
              </div>
            </div>
          </template>
        </VanCell> -->
        <!-- <VanCell>
          <template #title>
            <div class="flex items-center justify-between gap-2">
              <div>
                {{ $t(`mateWish.settings.aspectRatio`) }}
              </div>
              <div class="text-xs text-neutral-content flex items-center">
                <i class="iconify mingcute--right-line w-6"></i>
              </div>
            </div>
          </template>
          <template #label>
            <div class="flex px-6 my-4 gap-6">
              <div
                v-for="item in ['3:4', '16:9']"
                :key="item"
                :class="[
                  'flex flex-col items-center border relative',
                  mateWish.ratio === item
                    ? 'border-primary'
                    : 'border-transparent opacity-50',
                ]"
                @click="mateWish.ratio = item"
              >
                <VanImage
                  :src="
                    item === '3:4'
                      ? `/img/mate-wish/3-4.png`
                      : `/img/mate-wish/16-9.png`
                  "
                  :class="[
                    ' h-full min-h-[105px]',
                    `aspect-[${item === '3:4' ? '3/4' : '16/9'}]`,
                  ]"
                  crossorigin="anonymous"
                  alt=""
                />

                <span
                  class="font-bold my-2 absolute -bottom-8 left-[50%] translate-x-[-50%]"
                >
                  {{ item }}
                </span>

                <CheckCircleFillIcon
                  :class="[
                    'iconfont icon-check-circle-fill icon-xl absolute top-1 left-1',
                    mateWish.ratio === item ? 'text-primary' : 'opacity-0',
                  ]"
                />
              </div>
            </div>
          </template>
        </VanCell> -->
      </VanCellGroup>
      <!-- </VanTab> -->
      <!-- </VanTabs> -->

      <div
        class="flex flex-col items-center gap-2 pb-2 absolute bottom-0 px-5 left-0 right-0 shadow-inner pt-2 bg-base-100 z-[2]"
      >
        <VanRow class="w-full" gutter="8">
          <VanCol span="12">
            <button
              class="w-full btn btn-outline btn-sm"
              @click="router.push({ name: 'mateWishDemo' })"
            >
              {{ $t(`mateWish.viewDemo`) }}
            </button>
          </VanCol>

          <VanCol span="12">
            <button
              class="w-full btn btn-outline btn-sm"
              @click="showQa = true"
            >
              {{ t(`mateWish.whatTitle`) }}
            </button>
          </VanCol>
        </VanRow>
        <div class="flex items-center justify-center gap-2 w-full">
          <!-- <span class="text-sm font-medium">{{ $t(`mateWish.new`) }}:</span> -->
          <div class="flex gap-2 flex-1 items-center">
            <button
              class="btn btn-primary btn-sm w-full h-auto py-1 gap-1"
              @click="clickMateWish(1)"
            >
              <span class="flex items-center gap-1">
                <PowerIcon class="w-4 h-4" /> 10
              </span>
              <span>
                {{ $t(`mateWish.new`) }}
              </span>
            </button>
            <!-- <button
              class="btn btn-primary btn-sm h-auto py-1 flex-1 gap-1"
              @click="clickMateWish(2)"
            >
              <span class="flex items-center gap-1">
                <PowerIcon class="w-4 h-4" /> 9999
              </span>
              <span>
                {{ $t(`mateWish.newWithManual`) }}
              </span>
            </button> -->
          </div>
        </div>
      </div>
      <VanPopup position="bottom" v-model:show="showQa" closeable>
        <div v-html="html" class="prose prose-sm px-6 py-4"></div>
      </VanPopup>
    </div>

    <media-select-popup
      v-model:show="showStyleImgUploadPopup"
      :allow-crop-outside="false"
      :max-count="6"
      :multiple="false"
      :upload-type="0"
      media-type="img"
      replace
      @on-media-selected="onStyleSelected"
      :enable-avatar-gallery="true"
    />
  </div>
</template>

<script setup lang="ts">
import { createOneMateWish } from "@/apis/mate";
import { useMarkdownHTML } from "@/composable/text/useMarkdown";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { useMate } from "@/stores/mate";
import { useUI } from "@/stores/ui";
import {
  sessionStorageGet,
  sessionStorageRemove,
  sessionStorageSet,
} from "@/tools/sessionStorage";
import { MediaUploadFileItem } from "@/types/component";
import { Mate, MateWish, Media } from "@/types/entity";
import { showFailToast, showLoadingToast, showSuccessToast } from "vant";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

const mateWish = ref<Partial<MateWish>>({
  ratio: "16:9",
});
const mateStore = useMate();
const { t } = useI18n();
const router = useRouter();
const userStore = useGlobalUser();
const route = useRoute();

const uiStore = useUI();
const clickSelectLead = () => {
  uiStore.popMateSelector({
    mateOnly: true,
    switchMate: false,
    exclude: mateWish.value.characterIdzz || [],
    callback: (mate: Mate) => {
      // mateWish.value.mateId = mate.id;
      mateWish.value.characterIdzz = [];
      mateWish.value.characterIdzz = [
        ...(mateWish.value.characterIdzz || []),
        mate.id,
      ];
      uiStore.showMateSelector = false;
    },
  });
};
const { html } = useMarkdownHTML(t(`mateWish.what`));

const showQa = ref(false);
const modalStore = useGlobalModal();

const clickMateWish = async (generationType: number) => {
  mateWish.value.generationType = generationType;
  if (!mateWish.value.content)
    return showFailToast(t("mateWish.contentPlaceholder"));

  let count = generationType === 1 ? 10 : 9999;
  if (
    modalStore.shouldOpenPowerNotEnoughModal({
      spentPowerAmount: count,
      cb: () => clickMateWish(generationType),
    })
  )
    return;

  const loading = showLoadingToast(t(`Message.loading`));
  try {
    await createOneMateWish({
      content: mateWish.value.content,
      referenceImageIdzz:
        mateWish.value.referenceImagezz?.map((img) => img.id) || [],
      generationType: generationType,
      ratio: mateWish.value.ratio,
      // characterIdzz: [mateStore.currentMate!.id],
    });

    userStore.refresh();
    loading.close();
    showSuccessToast({
      message: t(`Message.opSuccess`),
      forbidClick: true,
      onClose: () => {
        if (route.query.from === "mateWishHome") {
          router.back();
        } else {
          router.replace({ name: "mateWishHome" });
        }
      },
    });

    sessionStorageSet("mate-wish-update", 1);
  } catch (e) {
    loading.close();
  }
};

const showStyleImgUploadPopup = ref(false);
const onStyleSelected = (list: MediaUploadFileItem[]) => {
  if (!mateWish.value.referenceImagezz) mateWish.value.referenceImagezz = [];

  for (const { mediaId, url } of list) {
    if (!mateWish.value.referenceImagezz.find((v) => v.id === mediaId)) {
      mateWish.value.referenceImagezz!.push({
        id: mediaId,
        url: url,
      } as Media);
    }
  }

  if (mateWish.value.referenceImagezz.length > 6) {
    mateWish.value.referenceImagezz = mateWish.value.referenceImagezz.slice(
      0,
      6
    );

    showFailToast("最多支持 6 张，已自动截取前 6 张");
  }

  showStyleImgUploadPopup.value = false;
};

onMounted(() => {
  const _mateWish = sessionStorageGet("mate-wish-edit");
  if (_mateWish) {
    const { content, referenceImagezz = [], characterIdzz } = _mateWish;
    mateWish.value = { content, referenceImagezz, ratio: "16:9" };
    if (characterIdzz?.length > 0) {
      const { mediaId, mediaUrl } = mateStore.getMyMateById(characterIdzz[0])!;
      if (mediaId && mediaUrl) {
        mateWish.value.referenceImagezz?.push({
          id: mediaId,
          url: mediaUrl,
        } as Media);
      }
    }

    sessionStorageRemove("mate-wish-edit");
  }
});
</script>

<style scoped>
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>

<style>
.mate-wish-edit-page .prose-sm ol li {
  list-style: decimal;
}
.mate-wish-edit-page .prose-sm ul li {
  list-style: circle;
}
</style>
